export function makeRange(start: number, stop: number, step: number = 1) {
  let values = [];
  for (let value = start; value < stop; value = value + step) {
    values.push(value);
  }

  return values;
}
